<template>
	<div class="goods home_goods" ref="wrapper">
		<!--顶部搜索框 -->
		<div class="nav">
			<van-icon name="arrow-left" size="1.2rem" color="#fff" @click="back" />
			<van-col span="24">
				<van-search v-model="value" @focus="serch" placeholder="您喜欢的" shape="round" background="#f1452f" />
			</van-col>
		</div>

		<!-- 综合列表 -->

		<van-row class="dropdown">
			<van-col style="width: 33.3%;" span="5" @click="toggTab(1)" :class="{active : flag==1}">
				<span class="esp">综合</span>
			</van-col>

			<van-col style="width: 33.3%;" span="5" @click="toggle" :class="{active : flag==5 || flag==6}">
				<div class="esp">
					<span>价格</span>
					<img v-if="flag==5" src="../../assets/up.png" alt="">
					<img v-else-if="flag==6" src="../../assets/down.png" alt="">
					<img v-else src="../../assets/default.png" alt="">
				</div>
			</van-col>

			<van-col style="width: 33.3%;" span="5" @click="toggTab(7)" :class="{active : flag==7}">
				<span class="esp">销量</span>
			</van-col>
		</van-row>
		<div class="container">
			<van-sidebar v-model="activeKey">
				<van-sidebar-item @click="getCatId('')" title="全部" />
				<van-sidebar-item @click="getCatId(item.id)" :title="item.title" v-for="item in screen_brand.category" />
			</van-sidebar>
			<!--商品列表 -->
			<div v-if="none" class="none">
				<div id="gundong">
					<div>暂无商品~</div>
				</div>
			</div>
			<van-list id="gundong" v-model="loading" :finished="finished" finished-text="我是有底线的" @load="onLoad" v-else>
				<ul class="left-waterfall" ref="left">
					<li class="item" v-for="(item, index) in leftItems" @click="setParams(item.id)">
						<img :src="item.image | handleUrl" alt="">
						<div class="main">
							<p>{{item.title}}</p>
							<!-- <div class="vangrid-bottom"></div> -->
							<div class="gongqi-tian" v-if="category_id == 1">
								<span v-if="item.goods_work == 7">工期7-10天</span>
								<span v-if="item.goods_work == 15">工期15-20天</span>
								<span v-if="item.goods_work == 30">工期30-40天</span>
							</div>
							<div class="vangrid-right">
								<span class="f1452f" v-if="category_id == 1">
									<span>租金¥</span>
									<span class="font-5">
										{{Number(item.price).toFixed(2).split(".")[0]}}</span>.{{Number(item.price).toFixed(2).split(".")[1]}}/月起</span>
								<span class="f1452f font-5" v-else>¥{{item.price}}</span>
								<!-- <span class="qido" v-if="category_id == 1">起</span> -->
							</div>
							<van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="item.hot_num" readonly v-if="category_id == 1" />
						</div>
					</li>
				</ul>
				<ul class="right-waterfall" ref="right">
					<li class="item" v-for="(item, index) in rightItems" @click="setParams(item.id)">
						<img :src="item.image | handleUrl" alt="">
						<div class="main">
							<p>{{item.title}}</p>
							<div class="gongqi-tian" v-if="category_id == 1">
								<span v-if="item.goods_work == 7">工期7-10天</span>
								<span v-if="item.goods_work == 15">工期15-20天</span>
								<span v-if="item.goods_work == 30">工期30-40天</span>
							</div>
							<div class="vangrid-right">
								<span class="f1452f" v-if="category_id == 1">
									<span>租金¥</span>
									<span class="font-5">
										{{Number(item.price).toFixed(2).split(".")[0]}}</span>.{{Number(item.price).toFixed(2).split(".")[1]}}/月起</span>
								<span class="f1452f font-5" v-else>¥{{item.price}}</span>
								<!-- <span class="qido" v-if="category_id == 1">起</span> -->
							</div>
							<div class="vangrid-bottomm">
								<van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="item.hot_num" readonly v-if="category_id == 1" />
							</div>
						</div>
					</li>
				</ul>
				<div style="clear:both"></div>
			</van-list>
		</div>
		<!-- </van-pull-refresh> -->
		<Footbar></Footbar>
	</div>
</template>

<script>
	import Footbar from '@/components/footbar';

	export default {
		name: 'home_class',
		data() {
			return {
				count: 0,
				isLoading: false,
				activeKey: 0,
				loading: false,
				finished: false,
				none: false,
				immediate_check: false,
				flag: 1, //导航条件
				show: false,
				//商品列表
				goods: [],
				leftItems: [],
				rightItems: [],
				brand: [],
				page: 1,
				value: '',
				screen_brand: [],
				category_id: 1,
				style_id: '',
				cat_id: '',
				brand_id: ''
			}
		},
		components: {
			Footbar
		},
		created() {
			if (this.$route.query.category_id) {
				this.category_id = this.$route.query.category_id
			}
			this.getTitle();
			//加载筛选条件
			this.$axios.post(baseUrl + '/mobile/Category/goodsCategory').then((res) => {
				if (res.data.code == 2) {
					this.screen_brand = res.data.data;
					this.cat_id = 0;
					this.getCatId(this.cat_id);
				}
			}).catch((err) => {
				console.log(err);
			});
		},
		//页面更新 加载异步数据
		updated: {
			// 异步更新数据
			onLoad() {
				this.$axios.post(baseUrl + '/mobile/Goods/goodsShow', {
					title: this.value,
					page: this.page,
					limit: 10,
					order: this.flag,
					category_id: this.category_id,
					style_id: this.style_id,
					cat_id: this.cat_id,
					brand_id: this.brand_id
				}).then((res) => {
					if (res.data.code == 2) {
						this.page++;
						setTimeout(() => {
							for (var i in res.data.data) {
								this.goods.push(res.data.data[i])
							}
							// 加载状态结束
							this.loading = false;
							this.updateWaterfall()
						}, 500)
					} else {
						this.loading = false;
						this.finished = true;
					}
				}).catch((err) => {
					console.log(err);
				});
			},
		},
		methods: {
			updateWaterfall() {
				const leftHeight = this.leftItems.length
				const rightHeight = this.rightItems.length
				let item = this.goods.shift();
				if (item == null) {
					return
				}
				if (item != undefined) {
					if (leftHeight <= rightHeight) {
						this.leftItems.push(item)
					} else {
						this.rightItems.push(item)
					}
				}
				this.$nextTick(() => {
					this.updateWaterfall();
				})
			},

			onRefresh() {
				setTimeout(() => {
					Toast('刷新成功');
					this.isLoading = false;
					this.count++;
				}, 1000);
			},

			//下拉刷新
			refresh(done) {
				setTimeout(() => {
					this.$toast("刷新完成")
					this.top = this.top - 30;
					done()
				}, 1500)
			},


			//获取title列表
			getTitle() {
				//初始化数据列表
				this.$axios.post(baseUrl + '/mobile/Goods/goodsShow', {
					title: this.value,
					page: this.page,
					limit: 10,
					order: this.flag,
					category_id: this.category_id,
					style_id: this.style_id,
					cat_id: this.cat_id,
					brand_id: this.brand_id
				}).then((res) => {
					if (res.data.code == 2) {
						this.page = 2;
						this.none = false;
						this.goodsShow();
						this.goods = res.data.data;
						this.updateWaterfall();
					} else {
						this.none = true;
					}

				}).catch((err) => {
					console.log(err);
				});
			},

			// 异步更新数据
			onLoad() {
				this.$axios.post(baseUrl + '/mobile/Goods/goodsShow', {
					title: this.value,
					page: this.page,
					limit: 10,
					order: this.flag,
					category_id: this.category_id,
					style_id: this.style_id,
					cat_id: this.cat_id,
					brand_id: this.brand_id
				}).then((res) => {
					if (res.data.code == 2) {
						// this.page = 2;
						this.page++;
						setTimeout(() => {
							if (this.page > 2) {
								for (var i in res.data.data) {
									this.goods.push(res.data.data[i])
								}
							}
							// 加载状态结束
							this.loading = false;
							this.updateWaterfall()
						}, 500)
					} else {
						this.loading = false;
						this.finished = true;
					}
				}).catch((err) => {
					console.log(err);
				});

			},
			//条件切换
			toggTab(fa) {
				this.flag = fa;
				this.page = 1;
				this.getTitle();
			},
			//价格切换
			toggle() {
				if (this.flag != 5) {
					this.flag = 5
				} else if (this.flag == 5) {
					this.flag = 6
				}
				this.page = 1;
				this.getTitle();
			},
			//切换导航数据
			goodsShow() {
				this.finished = false;
				this.leftItems = [];
				this.rightItems = [];

			},
			//跳转详情页
			setParams(em) {
				this.$router.push({
					path: '/Detail',
					query: {
						id: em
					}
				})
			},
			//提交筛选条件
			submit() {
				this.page = 1;
				this.show = false;
				this.getTitle();
			},
			//重置
			reset() {
				this.category_id = 1;
				this.style_id = '';
				this.brand_id = '';

			},
			//侧边导航栏切换
			getCatId(id) {
				this.page = 1;
				this.cat_id = id;
				this.getTitle();

			}
		},
		watch: {
			'$route'(to, from) {
				if (to.name === 'home_class') { //跳转的的页面的名称是"NewRecruit",这里就相当于我们listview页面，或者原始页面
					let savehdjkG = this.$store.state.savehdjhaY;
					//把在vuex里面的位置存入
					document.getElementById('gundong').scrollTop = savehdjkG
				}
			}
		},
		beforeRouteLeave(to, from, next) {
			//获取滚动条的高度
			let position = document.getElementById('gundong').scrollTop;
			//离开路由存起来
			if (position == null) position = 0
			this.$store.commit('savehdjkG', position) //离开路由时把位置存起来
			next()
		},

	}
</script>

<style scoped>
	@import '../pages/pages.css';

	.font-5 span:nth-child() {
		font-size: 0.6rem;
	}

	.gongqi-tian span {
		color: #969799;
	}

	.gongqi-tian {
		transform: scale(0.9);
		margin-left: -0.4rem;
		margin-top: 0.3rem;
	}

	.goods {
		height: calc(100% - 2rem);
		box-sizing: border-box;
		padding-bottom: 3rem;
		overflow: hidden;

	}

	.goods .none {
		font-size: 0.75rem;
		color: #B0B0B0;
		margin-top: 5rem;
		width: calc(100% - 4rem);
	}

	.qido {
		color: red;
		/*
    margin-top: 0.5rem;
    position: relative;
    top: 0.3rem;
    left: -0.1rem;
    margin-left: -0.1rem;
    transform: scale(0.8); */
	}

	.goods .none button {
		padding: 0 1rem;
		margin-top: 0.5rem;
	}

	.goods .dropdown {
		margin-bottom: 0.4rem;
		position: fixed;
		width: 100%;
	}

	.goods .dropdown span {
		font-size: 0.8rem;
	}

	.goods .container {
		display: flex;
		padding-top: 3rem;
		height: 100%;
		box-sizing: border-box;
	}

	/* 手机端样式 */

/* 	.goods .container {
		display: flex;
		padding-top: 3rem;
		height: 106%;
		box-sizing: border-box;
	} */

	.goods .dropdown .van-popup {
		padding-top: 2rem;
		opacity: 1;
	}

	.goods .van-list {
		width: calc(100% - 4rem);
		height: 100%;
		box-sizing: border-box;
		background: #f2f2f2;
		padding: 0 0.35rem;
		overflow-y: scroll;
		box-sizing: border-box;
	}

	.home_goods .van-list .main {
		position: unset;
	}

	.goods .van-list .main .font-5 {
		font-size: 1.1rem;
		font-weight: bold;

	}

	.goods img {
		width: 100%;
		object-fit: contain;
	}

	.van-sidebar {
		height: 100%;
		overflow-y: scroll;
	}

	.van-sidebar a {
		padding: 0.7rem 0;
	}

	.van-sidebar-item--select {
		color: #F1452F;
	}

	.main>>>.van-rate--readonly {
		padding-bottom: 0.6rem;
	}

	/* .f1452f span:nth-child(1){
    font-size: 0.6rem;
  } */
</style>



// WEBPACK FOOTER //
// src/components/home/home_class.vue